import { SalesPersonsGridView } from '~/components/customers/sales-persons';
import { PageContainer } from '~/components/page-container';

export function SalesPersons() {
	return (
		<PageContainer>
			<SalesPersonsGridView />
		</PageContainer>
	);
}
